<template>
    <div class="pb-6 px-6">
        <h3 class="font-semibold mb-6 text-v2-gray-80 text-xs uppercase">{{ searchInput.length || isViewAll ? 'Pins' : 'Recent pins' }}</h3>
        <div v-if="searchIsLoading" class="space-y-6">
            <PinItemSkeleton v-for="i in [1,2,3]" />
        </div>
        <ul v-else-if="!searchIsLoading && filteredPins?.length" class="space-y-6">
            <!-- Show the (3) most recent items pinned (which are added to Favorites by default). -->
            <PinItem v-for="pin in filteredPins" :pin="pin" />
        </ul>
        <PinSearchEmptyState v-else-if="!searchIsLoading && !filteredPins?.length && searchInput?.length" :query="searchInput" />
        <PinsEmptyState v-else class="-m-6" />
        <p v-if="!searchIsLoading && !searchInput" class="mt-6">
            <button
                :disabled="drawer.pins?.length < 1"
                @click="$emit('toggle:view-all')"
                class="disabled:opacity-50 disabled:pointer-events-none bg-v2-white border border-v2-gray-110 font-medium inline-block px-3 py-[3px] rounded text-[12px] text-v2-gray-20 hover:bg-v2-gray-130 dark:bg-v2-gray-60 dark:border-v2-gray-10 dark:text-v2-white dark:hover:bg-v2-gray-70"
            >
                View {{ isViewAll ? 'less' : 'all' }} <span v-if="drawer.pins?.length && !isViewAll">({{ drawer.pins?.length }})</span>
            </button>
        </p>
    </div>
</template>

<script setup>
import {usePinsDrawer} from "@/Composables";
import {computed} from "vue";
import {PinSearchEmptyState, PinsEmptyState, PinItem, PinItemSkeleton} from "@/Components";
import _ from "lodash";

const props = defineProps({
    searchInput: String,
    sortValue: Object,
    isViewAll: Boolean,
});
const { drawer, searchIsLoading } = usePinsDrawer();

const searchTerm = computed(() => props.searchInput || '');
const sortField = computed(() => props.sortValue.value[0])
const sortDir   = computed(() => props.sortValue.value[1])

const filteredPins = computed(() => {
    let allPins = drawer.value.pins

    if (searchTerm.value) {
        const term = searchTerm.value.toLowerCase()
        allPins = allPins.filter(pin =>
            pin.name.toLowerCase().includes(term)
        )
    }

    allPins = _.orderBy(allPins, [ sortField.value ], [ sortDir.value ])

    if (!props.isViewAll && !searchTerm.value) {
        return allPins.slice(0, 3)
    }
    return allPins;
});
</script>
